import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator"

export function SkipIfNotIsShared(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "skipIfNotIsShared",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          const object = args.object as any
          return !object.isShared ? true : value !== null && value !== ""
        },
        defaultMessage(args: ValidationArguments) {
          return typeof validationOptions?.message === "function"
            ? validationOptions.message(args)
            : validationOptions?.message || "error_fill"
        },
      },
    })
  }
}
